export const linkTheme = {
  MuiLink: {
    variants: [
      {
        props: { variant: "simpleLink" },
        style: ({ theme }) => ({
          color: "inherit",
          textDecoration: "none",
          "&:hover": {
            color: theme.palette.primary.main,
          },
        }),
      },
      {
        props: { variant: "menuLink" },
        style: ({ theme }) => ({
          fontSize: "32px",
          color: theme.palette.common.white,
          textDecoration: "none",
          "&:hover": {
            color: theme.palette.primary.main,
          },
        }),
      },
      {
        props: { variant: "baseLink" },
        style: ({ theme }) => ({
          textDecoration: "none",
          color: theme.palette.common.black,
        }),
      },
      {
        props: { variant: "outlinedLink" },
        style: ({ theme }) => ({
          color: theme.palette.primary.main,
          textDecoration: "none",
          padding: "5px 15px",
          border: `1px solid ${theme.palette.primary.light}`,
          borderRadius: "30px",
          fontSize: "14px",
          "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.light,
          },
        }),
      },
    ],
  },
};
